import { robinMediaArray } from './robinMedia'
import { robinBio } from './robinBios'
import { tedProfileReviewHinge, tedProfileReviewBumble, barneyProfileReviewTinder } from './robinProfileReviews'

export const robinDatingProfileHinge = {
  _id: 'robinDatingProfileHingeId',
  userId: 'robinUserId',
  email: 'robin@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: robinMediaArray[0]._id,
      mediaItemURL: robinMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[0].type,
      caption: robinMediaArray[0].captions[1],
      subcaption: robinMediaArray[0].subcaptions[2],
    },
    {
      mediaItemId: robinMediaArray[1]._id,
      mediaItemURL: robinMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[1].type,
      caption: robinMediaArray[1].captions[0],
      subcaption: robinMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[12]._id,
      mediaItemURL: robinMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[12].type,
      caption: robinMediaArray[12].captions[0],
      subcaption: robinMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[4]._id,
      mediaItemURL: robinMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[4].type,
      caption: robinMediaArray[4].captions[0],
      subcaption: robinMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[6]._id,
      mediaItemURL: robinMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[6].type,
      caption: robinMediaArray[6].captions[2],
      subcaption: robinMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[14]._id,
      mediaItemURL: robinMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[14].type,
      caption: robinMediaArray[14].captions[2],
      subcaption: robinMediaArray[14].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: robinBio._id,
    vitalInfo: { ...robinBio.vitalInfo },
    prompts: [
      { ...robinBio.prompts[0] },
      { ...robinBio.prompts[1] },
      { ...robinBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...tedProfileReviewHinge }
  ],
  mediaItems: [ ...robinMediaArray ],
  bioItems: { ...robinBio },
}

export const robinDatingProfileBumble = {
  _id: 'robinDatingProfileBumbleId',
  userId: 'robinUserId',
  email: 'robin@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: robinMediaArray[0]._id,
      mediaItemURL: robinMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[0].type,
      caption: robinMediaArray[0].captions[1],
      subcaption: robinMediaArray[0].subcaptions[2],
    },
    {
      mediaItemId: robinMediaArray[1]._id,
      mediaItemURL: robinMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[1].type,
      caption: robinMediaArray[1].captions[0],
      subcaption: robinMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[12]._id,
      mediaItemURL: robinMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[12].type,
      caption: robinMediaArray[12].captions[0],
      subcaption: robinMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[4]._id,
      mediaItemURL: robinMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[4].type,
      caption: robinMediaArray[4].captions[0],
      subcaption: robinMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[6]._id,
      mediaItemURL: robinMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[6].type,
      caption: robinMediaArray[6].captions[2],
      subcaption: robinMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[14]._id,
      mediaItemURL: robinMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[14].type,
      caption: robinMediaArray[14].captions[2],
      subcaption: robinMediaArray[14].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: robinBio._id,
    vitalInfo: { ...robinBio.vitalInfo },
    prompts: [
      { ...robinBio.prompts[0] },
      { ...robinBio.prompts[1] },
      { ...robinBio.prompts[2] }
    ],
    aboutMe: robinBio.aboutMe[0],
    hobbies: [robinBio.hobbies[0], robinBio.hobbies[1], robinBio.hobbies[2], robinBio.hobbies[3], robinBio.hobbies[4] ],
  },
  profileReviews: [
    { ...tedProfileReviewBumble }
  ],
  mediaItems: [ ...robinMediaArray ],
  bioItems: { ...robinBio },
}

export const robinDatingProfileTinder = {
  _id: 'robinDatingProfileTinderId',
  userId: 'robinUserId',
  email: 'robin@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: robinMediaArray[0]._id,
      mediaItemURL: robinMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[0].type,
      caption: robinMediaArray[0].captions[1],
      subcaption: robinMediaArray[0].subcaptions[2],
    },
    {
      mediaItemId: robinMediaArray[1]._id,
      mediaItemURL: robinMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[1].type,
      caption: robinMediaArray[1].captions[0],
      subcaption: robinMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[12]._id,
      mediaItemURL: robinMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[12].type,
      caption: robinMediaArray[12].captions[0],
      subcaption: robinMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[4]._id,
      mediaItemURL: robinMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[4].type,
      caption: robinMediaArray[4].captions[0],
      subcaption: robinMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[6]._id,
      mediaItemURL: robinMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[6].type,
      caption: robinMediaArray[6].captions[2],
      subcaption: robinMediaArray[6].subcaptions[0],
    },
    {
      mediaItemId: robinMediaArray[14]._id,
      mediaItemURL: robinMediaArray[14].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: robinMediaArray[14].type,
      caption: robinMediaArray[14].captions[2],
      subcaption: robinMediaArray[14].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: robinBio._id,
    vitalInfo: { ...robinBio.vitalInfo },
    prompts: [
      { ...robinBio.prompts[0] },
      { ...robinBio.prompts[1] },
      { ...robinBio.prompts[2] }
    ],
    aboutMe: robinBio.aboutMe[0],
    hobbies: [robinBio.hobbies[0], robinBio.hobbies[1], robinBio.hobbies[2], robinBio.hobbies[3], robinBio.hobbies[4] ],
  },
  profileReviews: [
    { ...barneyProfileReviewTinder }
  ],
  mediaItems: [ ...robinMediaArray ],
  bioItems: { ...robinBio },
}